export const textPrimary = "#5A5656";
export const textSecondary = "#707070";
export const textWhite = "#fff";
export const warningColor = "#149FCB";
